import { render, staticRenderFns } from "./navbarold.vue?vue&type=template&id=6747dce6&scoped=true&"
import script from "./navbarold.vue?vue&type=script&lang=js&"
export * from "./navbarold.vue?vue&type=script&lang=js&"
import style0 from "./navbarold.vue?vue&type=style&index=0&id=6747dce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6747dce6",
  null
  
)

export default component.exports